module.exports = {
    import: "Odber",
    export: "Dodávka",
    phase: "Fáza",
    quadrant: "Kvadrant",
    cumulative: "Kumulatív",
    average: "Priemer",
    voltage_profile: "Napäťový profil",
    voltage: "Napätie",
    average_voltage: "Priemerné napätie",
    current_profile: "Prúdový profil",
    current: "Prúd",
    cumulative_current: "Kumulatívny prúd",
    active_power_profile: "Činný výkonový profil",
    active_power: "Činný výkon",
    active_energy: "Činná energia",
    total_energy: "Celková energia",
    cumulative_active_power: "Kumulatívny činný výkon",
    reactive_power_profile: "Jalový výkonový profil",
    reactive_power: "Jalový výkon",
    cumulative_reactive_power: "Kumulatívny jalový výkon",
    apparent_power_profile: "Zdanlivý výkonový profil",
    energy_import: "Energia odber",
    energy_export: "Energia dodávka",
    energy_day: "Denný odber energie",
    realtime_voltage: "Napäťový profil v reálnom čase",
    realtime_current: "Prúdový profil v reálnom čase",
    realtime_active_power: "Činný výkonový profil v reálnom čase",
    realtime_reactive_power: "Jalový výkonový profil v reálnom čase",
    realtime_apparent_power: "Zdanlivý výkonový profil v reálnom čase",
    realtime_energy_import_profile: "Odber energie v reálnom čase",
    realtime_energy_export_profile: "Dodávka energie v reálnom čase",
    appliances_energy: "Spotreba energie rozpoznaných spotrebičov",
    appliances_timeline: "Časová os spotrebičov",
    pq_map: "PQ mapa odtlačkov spotrebičov",
    locations: "Umiestnenia",
    active_energy_last_24_hours: "Činná energia za posledných 24 hodín",
    active_energy_last_14_days: "Činná energia za posledných 14 dní",
    active_energy_last_12_months: "Činná energia za posledných 12 mesiacov",
    reactive_energy_last_24_hours: "Jalová energia za posledných 24 hodín",
    reactive_energy_last_14_days: "Jalová energia za posledných 14 dní",
    reactive_energy_last_12_months: "Jalová energia za posledných 12 mesiacov",
    hourly_total_active_energy: "Hodinová celková činná energia",
    daily_total_active_energy: "Denná celková činná energia",
    monthly_total_active_energy: "Mesačná celková činná energia",
    daily_total_reactive_energy: "Denná celková jalová energia",
    active_power_profile_with_appliances: "Činný výkonový profil so spotrebičmi",
    energy_consumption: "Spotreba energie",
    duration: "Trvanie",
    runtime: "Beh",
    viewFullscreen: "Zobraziť na celej obrazovke",
    printChart: "Tlač grafu",
    downloadPNG: "Stiahnuť PNG",
    downloadJPEG: "Stiahnuť JPEG",
    downloadPDF: "Stiahnuť PDF",
    downloadSVG: "Stiahnuť SVG",
    downloadCSV: "Stiahnuť CSV",
    downloadXLS: "Stiahnuť XLX",
    viewData: "Zobraziť tabuľku s údajmi",
    openInCloud: "Otvoriť v Highcharts Cloud",
    resetZoom: "Obnoviť priblíženie",
    loading: "Načítavam...",
    contextButtonTitle: "Obsahové menu",
    scaleChange: "Zmena mierky",
    weekdays: ["Nedeľa", "Pondelok", "Utorok", "Streda", "Štvrtok", "Piatok", "Sobota"],
    months: ['Január', 'Február', 'Marec', 'Apríl', 'Máj', 'Jún', 'Júl', 'August', 'September', 'Október', 'November', 'December'],
    shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'Máj', 'Jún', 'Júl', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
    monitoring_availability: "Podiel dostupnosti za 24 hodín",
    percentage_availability: "Percentuálny podiel dostupnosti",
    uptime: "Percentuálny čas online",
    drillUpText: "◁ Späť k {series.name}",
    other: "Ostatné",
    always_on: "Vždy zapnuté",
    relay: "Relé",
    disconnector_timeline: "Časová os relé",
    average_current: "Priemerný prúd",
    average_active_power: "Priemerný činný výkon",
    active_energy_import: "Činná energia odber",
    active_energy_export: "Činná energia dodávka",
    frequency: "Frekvencia",
    quarter_hour_active_energy: "Činná energia za 15 minút",
    quarter_hour_maximum_active_power: "Maximum činného výkonu za 15 minút",
    noData: "Dáta nie sú k dispozícii",
    reactive_energy: "Reaktívna energia",
    sample: "Vzorka",
    year_anomaly_title: "Ročný model spotrebiča",
    month_anomaly_title: "Mesačný model spotrebiča",
    week_anomaly_title: "Týždenný model spotrebiča",
    day_anomaly_title: "Denný model spotrebiča",
    duration_anomaly_title: "Model dlžky trvania zapnutého spotrebiča",
    runrun_anomaly_title: "Model dlžky trvania medzi zapnutiami spotrebiča"
}